if (!customElements.get('kr-purchase-assurance')) {
  customElements.define('kr-purchase-assurance', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('[data-kr-dialog-open]').forEach(button => {
        button.addEventListener('click', () => {
          const dialog = this.querySelector(`[data-kr-dialog="${button.dataset.krDialogOpen}"]`);
          if (dialog && !dialog.open) dialog.showModal();
        });
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-kr-dialog-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
    }
  });
}
